import { render, staticRenderFns } from "./VSelectSubject.vue?vue&type=template&id=4580cf0b&"
import script from "./VSelectSubject.vue?vue&type=script&lang=js&"
export * from "./VSelectSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4580cf0b')) {
      api.createRecord('4580cf0b', component.options)
    } else {
      api.reload('4580cf0b', component.options)
    }
    module.hot.accept("./VSelectSubject.vue?vue&type=template&id=4580cf0b&", function () {
      api.rerender('4580cf0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/components/VSelectSubject.vue"
export default component.exports